<p class="title">Control panel</p>

<div class="form-element">
  <mat-checkbox color="primary" [formControl]="excelBehaviour" (change)="onExcelBehaviour($event.checked)">Excel
    simulation
    (correction factor)
  </mat-checkbox>
</div>

<mat-form-field class="form-element">
  <mat-label>Min Lift:</mat-label>
  <input matInput class="right" type="number" placeholder="Min Lift:" [formControl]="minLift"
    (input)="onMinLift($event.target.value)">
  <span matSuffix>m</span>
  @if (minLift.hasError('required')) {
    <mat-error>
      Min Lift is required.
    </mat-error>
  }
  @if (minLift.hasError('min')) {
    <mat-error>
      Min Lift value should be arrange from 0 ~ 10000.
    </mat-error>
  }
  @if (minLift.hasError('max')) {
    <mat-error>
      Min Lift value should be arrange from 0 ~ 10000.
    </mat-error>
  }
</mat-form-field>

<mat-form-field class="form-element">
  <mat-label>Max Lift:</mat-label>
  <input matInput class="right" type="number" placeholder="Max Lift:" [formControl]="maxLift"
    (input)="onMaxLift($event.target.value)">
  <span matSuffix>m</span>
  @if (maxLift.hasError('required')) {
    <mat-error>
      Max Lift is required
    </mat-error>
  }
  @if (maxLift.hasError('min')) {
    <mat-error>
      Max Lift value should be arrange from 0 ~ 10000.
    </mat-error>
  }
  @if (maxLift.hasError('max')) {
    <mat-error>
      Max Lift value should be arrange from 0 ~ 10000.
    </mat-error>
  }
</mat-form-field>

<mat-form-field class="form-element">
  <mat-label>Split Power:</mat-label>
  <input matInput class="right" type="number" placeholder="Split Power:" [formControl]="splitPower"
    (input)="onSplitPower($event.target.value)">
  <span matSuffix>W</span>
  @if (splitPower.hasError('required')) {
    <mat-error>
      Split Power is required
    </mat-error>
  }
  @if (splitPower.hasError('min')) {
    <mat-error>
      Split Power value should be arrange from 0 ~ 200000.
    </mat-error>
  }
  @if (splitPower.hasError('max')) {
    <mat-error>
      Split Power value should be arrange from 0 ~ 200000.
    </mat-error>
  }
</mat-form-field>

<div class="actionBtn">
  <button mat-raised-button color="primary" (click)="onCalculate()">CALCULATE COEFFICIENT</button>
</div>
<div class="actionBtn special double">
  <button mat-raised-button color="primary" (click)="onBack()">Back</button>
  <button mat-raised-button color="warn" (click)="onSave()">SAVE</button>
</div>
<div class="actionBtn special">
  @if (!isAllManulSelected) {
    <button mat-raised-button color="primary" (click)="onSwitch('auto')">SELECT ALL
    AUTO</button>
  }
  @if (isAllManulSelected) {
    <button mat-raised-button color="primary" (click)="onSwitch('manul')">SELECT ALL
    MANUAL</button>
  }
</div>